import { Message } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

export default function Unauthorized() {
	const { t } = useTranslation();

	return <Message error>{t("notAuthorized", "You are not authorized")}</Message>;
}
